import { HttpService, ModalService } from '@philips-emr/tws-core/lib/services';

import { Endpoints } from '../definitions/endpoints';

interface Amendment {
  nrSeqTermo: number;
  tipoConfirmacao: string;
  termo: string;
  ieObrigatorio: string;
  nrSeqSegurado: number;
}

export default class ContractAmendmentService {

  public static openAmendsModal(amendment: Amendment): void {
    if (amendment) {
      ModalService.openDefault({
        id: 'amendment-modal',
        closeable: false,
        fragment: 'aditivo-contratual-detalhes',
        title: amendment.tipoConfirmacao,
        contextData: { nrSeqTermo: amendment.nrSeqTermo },
      });
    }
  }

  public static checkAmends(nrSeqBeneficiario: string): void {

    void HttpService.get<Amendment[]>(Endpoints.GET.CONTRACT_AMENDMENTS, { nrSeqBeneficiario }).then((response) => {
      const amendments = response.body;

      if (amendments && amendments.length > 0) {
        const amendment = amendments.pop();
        if (amendment) {
          this.openAmendsModal(amendment);
        }
      }
    });
  }

}

export type {
  Amendment,
};
